import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaSpotify } from "react-icons/fa";
import { MdAlternateEmail } from "react-icons/md";

const muiTheme = createTheme({
    palette: {
        custom: {
            main: '#FFF'
        },
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#009BB5",
                }
            }
        }
    }
});

const useStyles = theme => ({
    panel: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        background: '#000',
    },
    content: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        padding: '50px 0',
    },
    find: {
        fontFamily: 'Montserrat',
        fontSize: '1.2em',
        fontWeight: 'bold',
        lineHeight: '1.2em',
        textTransform: 'uppercase',
    },
    social: {
        padding: '20px 0',
        fontSize: '3em',

        '& a': {
            padding: '0 8px',
            textDecoration: 'none',
            color: 'inherit',
        },

        '& a:hover': {
            textDecoration: 'none',
            color: 'inherit',
        },
    },
    copyright: {
        fontFamily: 'Montserrat',
        fontSize: '1.4em',
        lineHeight: '1.4em',

    }
});

class FooterPanel extends React.PureComponent {
    render() {
        const { classes } = this.props;
        const currentYear = new Date().getFullYear();

        return (
            <ThemeProvider theme={muiTheme}>

                <div className={classes.panel}>
                    <div className={classes.content}>

                        <div className={classes.find}>Find us online</div>

                        <div className={classes.social}>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/dragoncommunitygym"><FaFacebookF /></a>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/dragoncommunitygym"><FaLinkedin /></a>
                            <a target="_blank" rel="noopener noreferrer" href="https://open.spotify.com/episode/2ANUhgn2BhIHH6ezkix2Vd?si=b5a51efb1aa748f4"><FaSpotify /></a>
                            <a target="_blank" rel="noopener noreferrer" href="mailto:matt@dragoncommunitygym.com"><MdAlternateEmail /></a>
                        </div>

                        <div className={classes.copyright}>&copy; Dragon Community Gym - {currentYear}</div>
                    </div>
                </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(FooterPanel)